import React, { ReactElement, useState } from "react";
import { useSelector } from "react-redux";

import FormControlLabel from "@mui/material/FormControlLabel";
import BaseSwitch, { SwitchProps } from "@mui/material/Switch";

import { useDispatch } from "../../store";
import { ReduxFormProps } from "../../types/ReduxForm";

type ReduxSwitchProps = SwitchProps &
  ReduxFormProps & {
    label: string;
  };

const Switch = ({
  path,
  setter,
  getter,
  label,
  disabled = false,
  ...props
}: ReduxSwitchProps): ReactElement => {
  const value = useSelector(getter(path, false)) as boolean;
  const dispatch = useDispatch();
  const [val, setVal] = useState(value);

  return (
    <FormControlLabel
      control={
        <BaseSwitch
          {...props}
          checked={val}
          color="primary"
          disabled={disabled}
          onChange={(evt): void => {
            setVal(evt.target.checked);
            dispatch(setter({ path, value: evt.target.checked }));
          }}
          onKeyPress={(evt) => {
            if (evt.key === "Enter") {
              setVal(!val);
              dispatch(setter({ path, value: !val }));
            }
          }}
        />
      }
      label={label}
    />
  );
};

export default Switch;
